module.exports = __webpack_public_path__ + "static/media/metodicheskie_ukazaniya.b4eb69c0.pdf";